const initialState = {
  nbsVo: null,
  nbsError: '',
  nbsLoaded: false,
  nbsApiError: false,
  dbrFlag: false,
  unifiedNbsData: '',
  unifiedNbsFFlag: false,
};

const NBS = (state = initialState, action) => {
  switch (action.type) {
    case 'NBS_RECEIVED':
      return {
        ...state,
        nbsVo: action.response,
        dbrFlag: action.dbrFlag,
        nbsLoaded: true,
        nbsApiError: false,
      };
    case 'NBS_ERROR':
      return {
        ...state,
        nbsError: action.response,
        nbsApiError: true,
      };
    case 'NBS_UPDATE':
      return {
        ...state,
        nbsLoaded: action.response,
      };
    case 'NBS_CART_ID_UPDATE':
      return {
        ...state,
        unifiedNbsData: action.response,
        unifiedNbsFFlag: action.fFlag,
      };
    default:
      return state;
  }
};

export default NBS;
